const DEFAULT_DEV_API_ORIGIN = 'http://localhost:5134';
const PRODUCTION_CUSTOMER_HOST = 'analyze.nyafaz.com';
const PRODUCTION_API_PATH = '/nyafaz-ep-makeup-api';

function apiBaseFromNyafazEpPath() {
  if (typeof window === 'undefined') return '';
  const path = String(window.location.pathname || '');
  if (!path.includes('/nyafaz-ep/')) return '';
  const origin = window.location?.origin;
  if (!origin) return '';
  return `${origin.replace(/\/$/, '')}${PRODUCTION_API_PATH}`;
}

function isLocalDevOrigin(origin) {
  if (!origin) return false;
  try {
    const { hostname, port } = new URL(origin);
    const isLocalHost =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '[::1]' ||
      hostname.endsWith('.local');
    return isLocalHost && (port === '3000' || port === '');
  } catch {
    return false;
  }
}

function productionApiOriginForHost(origin) {
  try {
    const url = new URL(origin);
    if (String(url.hostname || '').toLowerCase() === PRODUCTION_CUSTOMER_HOST) {
      return `${url.origin}${PRODUCTION_API_PATH}`;
    }
  } catch {
    // ignore
  }
  return null;
}

export function getMakeupHairApiBaseUrl() {
  const fromPath = apiBaseFromNyafazEpPath();
  if (fromPath) return fromPath;

  const fromNaturalsEnv =
    typeof process !== 'undefined' && process.env && process.env.REACT_APP_NATURALS_MAKEUP_HAIR_API_URL;
  if (fromNaturalsEnv && String(fromNaturalsEnv).trim()) {
    return String(fromNaturalsEnv).trim().replace(/\/$/, '');
  }

  const fromEnv = typeof process !== 'undefined' && process.env && process.env.REACT_APP_MAKEUP_HAIR_API_URL;
  if (fromEnv && String(fromEnv).trim()) return String(fromEnv).trim().replace(/\/$/, '');

  if (typeof window !== 'undefined') {
    const fromWindow =
      window.NYAFAZ_NATURALS_MAKEUP_HAIR_API_URL ||
      window.REACT_APP_NATURALS_MAKEUP_HAIR_API_URL;
    if (fromWindow && String(fromWindow).trim()) return String(fromWindow).trim().replace(/\/$/, '');

    const origin = window.location && window.location.origin;
    if (isLocalDevOrigin(origin)) return `${origin.replace(/\/$/, '')}${PRODUCTION_API_PATH}`;

    const mapped = origin ? productionApiOriginForHost(origin) : null;
    if (mapped) return mapped;

    if (origin) return origin;
  }

  return DEFAULT_DEV_API_ORIGIN;
}

export const MAKEUP_HAIR_API_PREFIX = '/api/makeup-hair';
export const MAKEUP_API_PREFIX = '/api/haircut/makeup';

export function getSkinToneApiUrl() {
  return `${getMakeupHairApiBaseUrl().replace(/\/$/, '')}/api/haircut/analyze-skin-tone`;
}

export function getMakeupApiUrl(path = '') {
  const base = getMakeupHairApiBaseUrl().replace(/\/$/, '');
  const suffix = path ? (path.startsWith('/') ? path : `/${path}`) : '';
  return `${base}${MAKEUP_API_PREFIX}${suffix}`;
}
